import React, { useEffect, useState, useRef } from 'react';
import { createPortal } from 'react-dom';

import './style.scss';

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const LoadingImage = (props) => {
  const { isApiLoaded, onClosing, onClosed, onStarted } = props;
  const [enabled, setEnabled] = useState(true);
  const [enableAnimation, setEnabledAnimation] = useState(false);
  const [progressComplete, setProgressComplete] = useState(false);

  useEffect(() => {
    // fire onStarted after 3s from mount
    const startedTimer = setTimeout(() => {
      onStarted && onStarted();
    }, 3000);

    return () => clearTimeout(startedTimer);
    // eslint-disable-next-line
  }, []);

  // useEffect(() => {
  //   if (isApiLoaded) {
  //     (async () => {
  //       const elapsedTime = Date.now() - startTimer.current;

  //       if (elapsedTime < 4000) {
  //         await delay(4000);
  //       }
  //       setEnabledAnimation(true);
  //       await delay(3000);
  //       onClosing && onClosing();
  //       setEnabled(false);
  //       onClosed && onClosed();
  //       window.logMessage('Loading image closed');
  //     })();
  //   }
  //   // eslint-disable-next-line
  // }, [isApiLoaded]);

  useEffect(() => {
    if (isApiLoaded && progressComplete) {
      (async () => {
        setEnabledAnimation(true);
        await delay(3000); // fade-out animation duration
        onClosing && onClosing();
        setEnabled(false);
        onClosed && onClosed();
        window.logMessage('Loading image closed');
      })();
    }
    // eslint-disable-next-line
  }, [isApiLoaded, progressComplete]);

  const progress = useRef(0);
  const progressEl = useRef(null);

  useEffect(() => {
    const updateProgress = () => {
      const el = progressEl.current;
      if (el) {
        el.style.width = `${progress.current}%`;
      }
    };

    const timer = setInterval(() => {
      if (progress.current < 100) {
        progress.current += 1;
        updateProgress();
      } else {
        setProgressComplete(true);
        clearInterval(timer);
      }
    }, 40); // 40ms * 100 = 4000ms = 4s

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      {enabled
        ? createPortal(
            <div
              className={`loading-container ${
                enableAnimation ? 'fade-out' : ''
              }`}
            >
              {/* <BackgroundLayer /> */}
              {/* <div className="loading-pattern">
            <img src={patternPng} alt="Loading pattern" />
          </div> */}
              <div className="loading-image">
                <img
                  src={'/assets/images/logo/aurora.webp'}
                  alt="Loading intro"
                />
                <div className="loading-bar">
                  <p ref={progressEl} className="loading-progress">
                    &nbsp;
                  </p>
                </div>
              </div>
            </div>,
            document.body
          )
        : null}
    </>
  );
};

export default LoadingImage;
